import * as echarts from 'echarts';
import PageCharts from '../page-charts';
import comOpt from './common-options.json';
import { merge } from 'lodash';

const aggregateFunctions = (names) => {
  return names.map((name) => PageCharts[name]);
};

const aggregate = (pages, datesRangePosts, datesRangeStories, names) => {
  const days = aggregateFunctions(names)
    .map((f) => f({ pages, datesRangePosts, datesRangeStories }))
    .flat();
  const result = {};

  for (const day of days) {
    day.formatDate = moment(day.date).format('MMM DD');
    result[day.formatDate] = {
      ...result[day.formatDate],
      ...day,
    };
  }
  return Object.values(result);
};

const create = ({ pages, datesRangePosts, datesRangeStories, names, ref, colors }) => {
  return new Promise((resolve, reject) => {
    const chart = echarts.init(ref, null, {
      renderer: 'canvas',
      useDirtyRect: false,
    });

    const data = aggregate(pages, datesRangePosts, datesRangeStories, names);

    const categories = data.map((item) => item.formatDate);

    const series = names.map((name, index) => {
      const dataSeries = data.map((item) => item[`${name}_0`] || 0);
      return {
        name: name,
        type: 'bar',
        stack: 'total',
        data: dataSeries,
        barWidth: '20%',
        itemStyle: {
          color: colors[index].value,
          borderRadius: 3,
          borderWidth: 0.5,
          borderColor: '#fff',
        },
        emphasis: {
          focus: 'series',
        },
      };
    });

    const option = merge({}, comOpt, {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          lineStyle: {
            color: '#C2D5FF',
            type: 'line'
          }
        },
        formatter: function (params) {
          let tooltipHtml = `<div class='tooltip'><span class='date'>${params[0].axisValue}</span><ul class='tooltip-list'>`;
          params.forEach((param) => {
            tooltipHtml += `<li>
                <div class="soc-sea ${colors[param.seriesIndex].key}">${param.seriesName}</div>${param.data.toLocaleString('ru-RU')}
              </li>`;
          });
          tooltipHtml += '</ul></div>';
          return tooltipHtml;
        },
        //appendToBody: true
      },
      xAxis: {
        type: 'category',
        data: categories,
      },
      yAxis: {
        type: 'value',
      },
      series: series,
    });

    chart.setOption(option);

    resolve(chart);
    window.addEventListener('resize', () => {
      chart.resize();
    });
  });

};

export default create;